import { Map, List, OrderedMap } from "immutable";
import moment from "moment";
import { createSelector } from "reselect";

export const getFormDraft = (state, key) => state.forms.drafts.get(`${key}`, Map());
export const getOpenForm = (state, key) => state.forms.open.get(`${key}`);

export const getFormAttachedUploadedFilesCodes = (state, key) => {
  return getFormDraft(state, key).get(`attach_uploaded_files`, List());
};

export const getFormUnfinishedFileUploadsCodes = (state, key) => {
  return state.forms.unfinished_file_uploads.get(`${key}`, List());
};

// will not return draft if it's older than 60 minutes
export const getTaskFormDraft = createSelector(getFormDraft, (draft) => {
  if (
    draft &&
    draft.get(`timestamp`) &&
    moment.utc(draft.get(`timestamp`)).isAfter(moment.utc().subtract(1, `hours`))
  ) {
    draft = draft.toJSON();
    draft.labels = OrderedMap(draft.labels);
    draft.subscribers = List(draft.subscribers);
    draft.labelIds = List(draft.labelIds);
    draft.labelNames = List(draft.labelNames);
    draft.isDraft = true;
    return draft;
  }
  return null;
});

export const getCommentFormDraft = createSelector(getFormDraft, (draft) => {
  if (
    draft &&
    draft.get(`timestamp`) &&
    moment.utc(draft.get(`timestamp`)).isAfter(moment.utc().subtract(1, `hours`))
  ) {
    return draft;
  }

  return undefined;
});
